export type ProductFolder = {
  slug: string
  label: string
  order: number
}

export const PRODUCT_FOLDERS: ProductFolder[] = [
  { slug: 'drawing', label: '01. Drawing', order: 1 },
  { slug: 'bom', label: '02. BOM', order: 2 },
  { slug: 'ai', label: '03. AI', order: 3 },
  { slug: 'packing', label: '04. Packing', order: 4 },
  { slug: 'picture', label: '05. Picture', order: 5 },
  { slug: 'customer-information', label: '06. Customer Information', order: 6 },
  { slug: 'cnc', label: '07. CNC', order: 7 },
  { slug: 'report', label: '08. Report', order: 8 },
]

export function getFolderBySlug(slug: string): ProductFolder | undefined {
  return PRODUCT_FOLDERS.find((f) => f.slug === slug)
}
